/**
 * EM3 Identity Types
 *
 * Central type definitions for user identity, roles, and authentication.
 * Used by both frontend and backend — no platform-specific imports.
 */

// All role strings match exactly what FusionAuth puts in JWT claims.
export const EM3_ROLES = {
  // Access tiers
  USER: 'user',
  ADMIN: 'admin',

  // Regional (one per user — where they work)
  HQ: 'HQ',
  INUVIK: 'Inuvik',
  SOUTH_SLAVE: 'South Slave',
  SAHTU: 'Sahtu',
  DEH_CHO: 'Deh Cho',
  NORTH_SLAVE: 'North Slave',
  WBNP: 'WBNP',

  // Duty context (one per user — operational role)
  RDO: 'RDO',
  TDO: 'TDO',
  MOF: 'MOF',
  SUPERINTENDENT: 'superintendent',
  DIRECTOR: 'Director',

  // Specialized contributor roles
  WEATHER_CONTRACTOR: 'WeatherContractor',
  COMM_TECH: 'COMMTech',
  MODELLER: 'Modeller',
  VAR_MANAGER: 'VARManager',
  MAPPER: 'Mapper',

  // Implicit roles granted by group membership (e.g. RDO/TDO groups grant
  // DutyLogReader, which permits read-only duty log access without granting
  // any other elevated capability).
  DUTY_LOG_READER: 'DutyLogReader',
} as const;

export type EM3Role = typeof EM3_ROLES[keyof typeof EM3_ROLES];

export interface EM3User {
  id: string;           // FusionAuth user UUID (sub claim)
  username: string;     // preferred_username or email prefix
  email: string;
  firstName?: string;
  lastName?: string;
  roles: EM3Role[];     // All roles from JWT for this application
}
